import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyOrEmpty' })
export class CurrencyOrEmptyPipe implements PipeTransform {
	transform(value: number): string {
		if (value === null || value === 0) { return ''; }
		return new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP', minimumFractionDigits: 2 }).format(value);
	}
}
